import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import classNames from 'classnames'
import styles from './styles.module.css'


const projects = require('../data/projects')

const ProjectDetail = ({ history, pathContext }) => {
    const data = projects[pathContext.projectsKey].find(project => project.url === pathContext.url)

    return (
        <div className={classNames('portfolio-item-showcase', styles.project)}>
            <Helmet>
                <title>{data.title}</title>
            </Helmet>

            <div className="container">
                <div className="header">
                    <h3 onClick={history.goBack} style={{ cursor: 'pointer' }}>
                        «  Atrás
                    </h3>
                </div>
                <div className="project">
                    <h1>
                        {data.title}
                    </h1>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="description" dangerouslySetInnerHTML={{ __html: data.htmlFull() }} />
                        </div>
                        {/* <div className="col-md-4">
                            <div className="details" style={{ marginTop: 0 }}>
                                <p>
                                    <strong>Lorem: </strong>
                                    Quisque id arcu
                                </p>
                                <p>
                                    <strong>Lorem: </strong>
                                    Quisque id arcu
                                </p>
                                <p>
                                    <strong>Lorem: </strong>
                                    Quisque id arcu
                                </p>
                                <p>
                                    <strong>Lorem: </strong>
                                    Quisque id arcu
                                </p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProjectDetail


// WEBPACK FOOTER //
// ./src/components/ProjectDetail.js